import script from "./DocumentoEntradaGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentoEntradaGrid.vue?vue&type=script&setup=true&lang=js"

import "./DocumentoEntradaGrid.vue?vue&type=style&index=0&id=242aaf70&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-242aaf70"]])

export default __exports__